import LearningTimeWidget from './LearningTimeWidget'

export default LearningTimeWidget
